var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoupon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A14",
  d: "M4.35 3a2.7 2.7 0 0 0-2.7 2.7v2.847c1.298.524 2.212 1.771 2.212 3.229 0 1.457-.914 2.705-2.212 3.228v2.847a2.7 2.7 0 0 0 2.7 2.7h4.757V3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9B4F",
  d: "M21.901 8.547V5.701a2.7 2.7 0 0 0-2.7-2.7H9.11v17.55H19.2a2.7 2.7 0 0 0 2.7-2.7v-2.847c-1.298-.523-2.212-1.771-2.212-3.229 0-1.457.914-2.705 2.212-3.228Z"
})));
export default SvgCoupon;